export const checkIfDuplicateExists = w => {
  return new Set(w).size !== w.length
}
export const getDuplicatesFromArray = yourArray => {
  const yourArrayWithoutDuplicates = [...new Set(yourArray)]

  let duplicates = [...yourArray]
  yourArrayWithoutDuplicates.forEach(item => {
    const i = duplicates.indexOf(item)
    duplicates = duplicates.slice(0, i).concat(duplicates.slice(i + 1, duplicates.length))
  })
  return duplicates.toString()
}
